import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Header from '../components/landing/Header'
import Hero from '../components/landing/Hero'
import OurTrips from '../components/landing/OurTrips'
import PopularDestinations from '../components/landing/PopularDestinations'
import BrowseActivities from '../components/landing/BrowseActivities'
import BrowseCuriosities from '../components/landing/BrowseCuriosities'
import OurProducts from '../components/landing/OurProducts'
import Footer from '../components/landing/Footer'

const LandingPage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Gestisce la navigazione con hash (es. /#trips, /#destinations, /#activities)
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        // Aggiungi un piccolo delay per assicurarsi che la pagina sia caricata
        setTimeout(() => {
          const headerHeight = 80; // Altezza approssimativa dell'header
          const elementPosition = element.offsetTop - headerHeight;
          
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }, 100);
      }
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1 w-full">
        <Hero />
        <OurTrips />
        <OurProducts />
        <PopularDestinations />
        <BrowseActivities />
        <BrowseCuriosities />
      </main>
      <Footer isHomePage={true} />
    </div>
  )
}

export default LandingPage 